import { render, staticRenderFns } from "./CreateGDocModal.vue?vue&type=template&id=21e7b036&scoped=true"
import script from "./CreateGDocModal.vue?vue&type=script&lang=js"
export * from "./CreateGDocModal.vue?vue&type=script&lang=js"
import style0 from "./CreateGDocModal.vue?vue&type=style&index=0&id=21e7b036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e7b036",
  null
  
)

export default component.exports